import { MessageCircle, Phone } from "lucide-react";
import { CONTACT } from "@/content";

export const FloatingCTA = () => {
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col gap-3">
      <a
        href={CONTACT.whatsappHref}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-whatsapp-button"
        aria-label="WhatsApp schreiben"
        className="flex h-12 w-12 items-center justify-center rounded-full border border-border bg-card text-foreground shadow-lg shadow-black/40 transition-colors hover:bg-secondary"
      >
        <MessageCircle className="h-5 w-5" />
      </a>
      <a
        href={CONTACT.phoneHref}
        data-testid="sticky-phone-button"
        aria-label="Anrufen"
        className="fab-pulse flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground transition-transform hover:scale-105"
      >
        <Phone className="h-6 w-6" />
      </a>
    </div>
  );
};
